var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{staticClass:"notifications-menu__badge",attrs:{"color":"pink","value":_vm.getCartItems,"content":_vm.getCartItems}},[_c('v-btn',{attrs:{"max-width":"40px","max-height":"40px","icon":""},on:{"click":_vm.toggleCart}},[_c('v-icon',[_vm._v("mdi-cart")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }